/* eslint-disable */
export const messaging = {
  validation: {
    field: {
      required: 'This field cannot be empty.',
      stateError: 'Please select a state or territory.',
    },
    api: {
      street: {
        oldAddressMovingFromMilitaryToBusiness: 'This address is not acceptable for the move type of Business.',
        oldAmsMatch: 'We cannot find the address you\'re moving from in our records. Please modify your address and then resubmit.',
        newAmsMatch: 'We cannot find the address you\'re moving to in our records. Please modify your address and then click "Next."',
        oldInvalidPrimaryNumber: 'We cannot find the address that you entered in our records. Please check the spelling of all address information to ensure it is accurate.',
        newInvalidPrimaryNumber: 'We cannot locate the entered street number in our records. Please verify the address information is accurate. If you are certain the existing address is correct, you may proceed by clicking "Next."',
        invalidStreet: 'We cannot find the street address that you entered in our records. Please check the spelling of all address information to ensure it is accurate.  If you are sure the existing address is correct, please contact your local Post Office to validate your mailing address.',
        missingSecondaryNumber: 'A unit or apartment number is either missing, incomplete or invalid. Please add the correct number/designation after the street name in the "Street" field, then click "Next." USPS will standardize your address upon submission.',
        fullAddressFieldException: 'We cannot find the address in our records. The "Street Address" field should not include the city, state or ZIP. If you are sure this is the correct address, you may proceed by clicking "Next."',
        unneededSecondaryNumber: 'According to our records, there is no unit or apartment number associated with this address. Please verify the address for accuracy before continuing, and then click "Next."',
        droppedSecondaryNumber: 'According to our records, there is no unit or apartment number associated with this address. Please verify the address for accuracy before continuing, and then click "Next."',
        undeliverableAddress: 'The address that you entered is not a valid delivery address according to our database. Please contact your local Post Office to validate your mailing address.',
        invalidPrimaryPoBox: 'According to our records, this is an invalid box number. Please review and update the address before continuing, then click "Next."',
        newPrimaryNumberMissing: 'The street number of the street address is missing. Please add the street number and click "Next" to proceed.',
        oldPrimaryNumberMissing: 'We cannot find this address in our records. Please verify that the address is correct. Please verify the address for accuracy before continuing, and then click "Next."',
        privateMailbox: 'To forward mail to a commercial mail receiving agency, you must include the private mailbox number. Please enter the private mailbox number in the “Private Mailbox” field, then click “Next.” USPS will standardize your address upon submission.',
        CCR1PrivateMailbox: 'Our records indicate the unit or apartment number is incorrect. Please correct the unit or apartment number in the "Street Address" field and add the Private Mailbox in the “Private Mailbox” field and click "Next." USPS will standardize your address when the “Next” button is clicked.',
        addressesMatch: 'The old address matches the new one. Please check your old and new address information and try again.',
        amsInvalidAddressException: 'We cannot find the address you\'re moving from in our records. Please modify your address and then click "Next."',
      },
      zip: {
        numeric: 'The ZIP Code™ should contain only numbers.',
        length: 'The ZIP Code™ should be 5 digits long.',
        zip5: (moverType) => `Change-of-Address orders from the ZIP Code™ you have selected cannot be completed for the ${moverType.toUpperCase()} move type. Please update your move type to continue.`,
        zip9: 'This ZIP Code™ is listed as restricted and may not be used for online Change-of-Address requests at this time.',
      },
    },
  },
  businessRule: {
    error: {
      cmra: 'Mail addressed to an addressee at commercial mail receiving agency (CMRA) is not forwarded through the USPS. The CMRA customer may make special arrangements for the CMRA operator to re-mail the mail with payment of new postage. A CMRA must accept and re-mail mail to former customers for at least 6 months after termination of the agency relationship. After the 6-month period, the CMRA may refuse mail addressed to a former customer. The Application for Delivery of Mail through Agent (PS Form 1583) requires an addressee and agent to comply with all applicable postal rules and regulations relative to delivery of mail through an agent. For more information on mail forwarding regulations, contact your local Postmaster.',
      fatalError: 'The Change-of-Address application has experienced an error and your request could not be processed.',
      oldAddress: 'We cannot find the address you\'re moving from in our records. Please click the "Edit Address" button to modify your address and then resubmit.',
      processingError: (amount) => `The Change-of-Address application has experienced an error and your request could not be processed. A temporary hold of $${amount} may be placed on your credit/debit card account, which should be canceled automatically within 3 to 7 business days depending on your bank's policy. Please retry entering your Change-of-Address.`,
      residentialBusiness: 'The Change-of-Address you have filed cannot be processed. Our database classifies the old address as non-residential or business. USPS policy does not allow Individual or Family move types to forward mail from a business or organization to a residential address. If you receive mail addressed to you individually at a business or organization address, please contact the business or organization to redirect your mail. For more information on mail forwarding regulations, contact your local Postmaster.',
      r777: 'Sorry, we are unable to accept your Change-of-Address request to forward mail to a non-deliverable address. For more information on mail forwarding regulations, please contact your local Post Office.',
      oldUniqueZip: 'Sorry, we are unable to accept changes to addresses with a unique ZIP Code via MoversGuide Online at this time. Mail addressed to an addressee with a unique ZIP Code cannot be forwarded. For more information on mail forwarding regulations, contact your local Postmaster.',
      newUniqueZip: 'Our address database has recognized your new address as a unique address, and we will forward your mail as requested. Please note that the USPS policy does not support forwarding mail from a unique address; if you change your address again in the future, you must contact the mail center for this business or institution to forward your mail.',
    },
  },
};

const FIELD_CONSTANTS = {
  SESSION: 'session',
  OLD_STREET: 'oldStreet',
  NEW_STREET: 'newStreet',
  OLD_ZIPCODE: 'oldZipcode',
  NEW_ZIPCODE: 'newZipcode',
};

const ERROR_CONSTANTS = {
  /*
   * NOT AN MGO Exception, this is added in
   * http.js:errorHandler when we receive a 400 response
   * and no response body
   */
  EXPIRED_COA: 'CoaExpired',

  /*
   * MGO 422 Exceptions
   */
  AMS_INVALID_STREET_ADDRESS_EXCEPTION: 'AmsInvalidStreetAddressException',
  INVALID_SECONDARY_INFORMATION_EXCEPTION: 'InvalidSecondaryInformationException',
  CMRA_ADDRESS_EXCEPTION: 'CmraAddressException',
  OLD_NEW_ADDRESS_MATCH_EXCEPTION: 'OldAndNewAddressMatchException',
  R777_EXCEPTION: 'R777AddressException',
  BUSINESS_MOVER_TYPE_EXCEPTION: 'BusinessMoverTypeException',
  ZIP_5_NOT_ELIGIBLE_EXCEPTION: 'Zip5NotEligibleException',
  INVALID_PRIMARY_INFORMATION_EXCEPTION: 'InvalidPrimaryInformationException',
  UNNEEDED_SECONDARY_NUMBER: 'UnneededSecondaryInformationException',
};

/**
 * Generate an exception object
 * useful for determining appropriate error messaging
 * This is meant to be used with a network response of 422
 * from MGOs API
 * @param {String} exception
 * @param {String} message
 * @param {Array} fields
 * @return {Self}
 */
function MycoaException(exception, message, fields) {
  this._exception = exception;
  this._message = message;
  this._fields = fields;
}

/**
 * determine if a field has an error message
 * @param {String} fieldName
 * @return {Boolean}
 */
MycoaException.prototype._fieldHasError = function (fieldName) {
  // Best not to incur computation cost if exceptions and
  // fields are not truthy
  if (!this._exception && !this._fields) return false;


  if (this._exception) {
    /*
     * The standard way to read this is
     * for this given exception
     * and the provided field
     * do we have an error?
     * Each exception can apply to multiple fields */
    switch (this._exception) {
      case ERROR_CONSTANTS.UNNEEDED_SECONDARY_NUMBER:
        return [
          FIELD_CONSTANTS.NEW_STREET,
          FIELD_CONSTANTS.OLD_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.INVALID_PRIMARY_INFORMATION_EXCEPTION:
        return [
          FIELD_CONSTANTS.NEW_STREET,
          FIELD_CONSTANTS.OLD_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.ZIP_5_NOT_ELIGIBLE_EXCEPTION:
        return [
          FIELD_CONSTANTS.OLD_ZIPCODE,
        ].includes(fieldName);

      case ERROR_CONSTANTS.BUSINESS_MOVER_TYPE_EXCEPTION:
        return [
          FIELD_CONSTANTS.OLD_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.R777_EXCEPTION:
        return [
          FIELD_CONSTANTS.NEW_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.OLD_NEW_ADDRESS_MATCH_EXCEPTION:
        return [
          FIELD_CONSTANTS.OLD_STREET,
          FIELD_CONSTANTS.NEW_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.CMRA_ADDRESS_EXCEPTION:
        return [
          FIELD_CONSTANTS.NEW_STREET,
        ].includes(fieldName);

      case ERROR_CONSTANTS.INVALID_SECONDARY_INFORMATION_EXCEPTION:
        return [
          FIELD_CONSTANTS.OLD_STREET,
        ].includes(fieldName);

      case 'InvalidStreetAddressException':
      case ERROR_CONSTANTS.AMS_INVALID_STREET_ADDRESS_EXCEPTION:
      case 'AmsMultipleAddressException':
        return [
          FIELD_CONSTANTS.OLD_STREET,
        ].includes(fieldName);

      default:
        return false;
    }
  }
};

/**
 * get error message of field it if exists
 * else get empty string
 * @param {String} fieldName
 * @return {String}
 */
MycoaException.prototype.getFieldError = function (fieldName, moveType = 'individual') {
  if (this._exception === ERROR_CONSTANTS.EXPIRED_COA
    && fieldName === 'session') return ERROR_CONSTANTS.EXPIRED_COA;

  if (!this._fieldHasError(fieldName)) return '';

  if (this._exception) {
    /*
     * The Standard way to read this is
     * Given this field
     * and this exception
     * return this mapped error,
     * Some errors are functions and must be called in the view */
    switch (fieldName) {
      case FIELD_CONSTANTS.OLD_ZIPCODE:
        switch (this._exception) {
          case ERROR_CONSTANTS.ZIP_5_NOT_ELIGIBLE_EXCEPTION:
            return messaging.validation.api.zip.zip5(moveType);

          default:
            this.logUnhandledError(fieldName);
            return '';
        }

      case FIELD_CONSTANTS.NEW_ZIPCODE:
        switch (this._exception) {
          default:
            this.logUnhandledError(fieldName);
            return '';
        }

      case FIELD_CONSTANTS.NEW_STREET:
        switch (this._exception) {
          case ERROR_CONSTANTS.UNNEEDED_SECONDARY_NUMBER:
            return messaging.validation.api.street.unneededSecondaryNumber;

          case ERROR_CONSTANTS.INVALID_SECONDARY_INFORMATION_EXCEPTION:
            return messaging.validation.api.street.missingSecondaryNumber;

          case ERROR_CONSTANTS.INVALID_PRIMARY_INFORMATION_EXCEPTION:
            return messaging.validation.api.street.newInvalidPrimaryNumber;

          case ERROR_CONSTANTS.R777_EXCEPTION:
            return messaging.validation.api.street.undeliverableAddress;

          case ERROR_CONSTANTS.OLD_NEW_ADDRESS_MATCH_EXCEPTION:
            return messaging.validation.api.street.addressesMatch;

          case ERROR_CONSTANTS.CMRA_ADDRESS_EXCEPTION:
            return messaging.validation.api.street.privateMailbox;

          default:
            this.logUnhandledError(fieldName);
            return '';
        }

      case FIELD_CONSTANTS.OLD_STREET:
        switch (this._exception) {
          case ERROR_CONSTANTS.UNNEEDED_SECONDARY_NUMBER:
            return messaging.validation.api.street.unneededSecondaryNumber;

          case ERROR_CONSTANTS.INVALID_PRIMARY_INFORMATION_EXCEPTION:
            return messaging.validation.api.street.oldInvalidPrimaryNumber;

          case ERROR_CONSTANTS.BUSINESS_MOVER_TYPE_EXCEPTION:
            return messaging.businessRule.error.residentialBusiness;

          case ERROR_CONSTANTS.OLD_NEW_ADDRESS_MATCH_EXCEPTION:
            return messaging.validation.api.street.addressesMatch;

          case ERROR_CONSTANTS.INVALID_SECONDARY_INFORMATION_EXCEPTION:
            return messaging.validation.api.street.missingSecondaryNumber;

          case ERROR_CONSTANTS.AMS_INVALID_STREET_ADDRESS_EXCEPTION:
            return messaging.validation.api.street.invalidStreet;

          default:
            this.logUnhandledError(fieldName);
            return '';
        }
      default:
        this.logUnhandledError(fieldName);
        return '';
    }
  }
};

/**
 * Log unhandled field errors
 * @param {String} fieldName
 */
MycoaException.prototype.logUnhandledError = function (fieldName) {
  // eslint-disable-next-line no-console
  console.error({
    exception: this._exception,
    fieldName,
    error: 'no error message',
  });
};

export default MycoaException;
